(function ($, Drupal, once) {
  'use strict';

  // Shared across Floating CTA and Floating Bar CTA: when a block carries a
  // Hubspot Form ID, its buttons open this modal (with that block's form)
  // instead of following their link. Also exposed as
  // Drupal.idexxHubspotModal.open() for the Product Picker Quiz.
  var PORTAL_ID = '3432537';
  var REGION = 'na1';
  var HS_SCRIPT_SRC = '//js.hsforms.net/forms/embed/v2.js';

  var modal;
  var box;
  var closeBtn;
  var formWrap;
  var loading;
  var hsScriptPromise;
  var lastTrigger;
  var savedScrollY = 0;
  var openGeneration = 0;
  var closeTimer;

  function ensureModal() {
    if (modal) {
      return;
    }

    modal = document.createElement('div');
    modal.id = 'hs-modal';
    modal.className = 'hs-modal';
    modal.setAttribute('aria-hidden', 'true');

    box = document.createElement('div');
    box.id = 'hs-modal-box';
    box.className = 'hs-modal__box';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-labelledby', 'hs-modal-title');

    closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.id = 'hs-modal-close';
    closeBtn.className = 'hs-modal__close';
    closeBtn.setAttribute('aria-label', Drupal.t('Close'));
    closeBtn.innerHTML = '&times;';

    var title = document.createElement('h3');
    title.className = 'hs-modal__title';
    title.id = 'hs-modal-title';
    title.textContent = Drupal.t('Book a Demo');

    formWrap = document.createElement('div');
    formWrap.id = 'hs-form';

    loading = document.createElement('div');
    loading.id = 'hs-form-loading';
    loading.className = 'hs-modal__loading';
    loading.textContent = Drupal.t('Loading…');

    box.appendChild(closeBtn);
    box.appendChild(title);
    box.appendChild(formWrap);
    box.appendChild(loading);
    modal.appendChild(box);
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        hideModal();
      }
    });
    closeBtn.addEventListener('click', hideModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        hideModal();
      }
    });
  }

  // While the popup is open, keep focus (and the page) where they are if
  // something moves focus behind it. Core's form.js focuses the target of any
  // clicked "#fragment" link 300ms later, so a trigger whose fallback URL is
  // "#form" scrolled the page down to #form behind the popup (IDX-186).
  function keepFocusInModal(e) {
    if (box.contains(e.target)) {
      return;
    }
    closeBtn.focus({ preventScroll: true });
    // Restore after the browser finishes the outside focus event's scrolling.
    window.requestAnimationFrame(function () {
      if (modal.classList.contains('is-open')) {
        window.scrollTo({ left: window.scrollX, top: savedScrollY, behavior: 'instant' });
      }
    });
  }

  function showModal() {
    clearTimeout(closeTimer);
    lastTrigger = document.activeElement;
    savedScrollY = window.scrollY;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    window.requestAnimationFrame(function () {
      if (modal.getAttribute('aria-hidden') === 'false') { modal.classList.add('is-visible'); }
    });
    document.body.style.overflow = 'hidden';
    document.addEventListener('focusin', keepFocusInModal);
    closeBtn.focus({ preventScroll: true });
  }

  function hideModal() {
    if (!modal || modal.getAttribute('aria-hidden') === 'true') { return; }
    openGeneration++;
    document.removeEventListener('focusin', keepFocusInModal);
    if (box.contains(document.activeElement) && lastTrigger && lastTrigger.focus) {
      lastTrigger.focus({ preventScroll: true });
    }
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-visible');
    document.body.style.overflow = '';
    closeTimer = setTimeout(function () {
      modal.classList.remove('is-open');
    }, 300);
  }

  function ensureHsScriptLoaded() {
    if (window.hbspt && window.hbspt.forms && window.hbspt.forms.create) {
      return Promise.resolve();
    }

    if (!hsScriptPromise) {
      hsScriptPromise = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.charset = 'utf-8';
        script.type = 'text/javascript';
        script.src = HS_SCRIPT_SRC;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }

    return hsScriptPromise;
  }

  // Reads name/value pairs from a rendered HubSpot form. HubSpot passes either
  // a jQuery-wrapped form or the raw element depending on the embed version.
  function readFormValues(form) {
    var el = form && form.jquery ? form[0] : form;
    var values = {};
    if (!el || !el.elements) {
      return values;
    }
    Array.prototype.forEach.call(el.elements, function (field) {
      if (!field.name || field.disabled) {
        return;
      }
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) {
        return;
      }
      values[field.name] = values[field.name] ? values[field.name] + ';' + field.value : field.value;
    });
    return values;
  }

  // Options (all optional):
  //  - onFormSubmitted(values): called after HubSpot accepts the submission,
  //    with the submitted values keyed by HubSpot property name.
  //  - onError(err): called if the HubSpot embed script fails to load.
  function openHubspotForm(formId, options) {
    options = options || {};
    ensureModal();
    modal.querySelector('.hs-modal__title').textContent = options.title || Drupal.t('Book a Demo');
    formWrap.innerHTML = '';
    loading.textContent = Drupal.t('Loading…');
    loading.removeAttribute('role');
    loading.style.display = 'block';
    showModal();

    var captured = null;
    var generation = ++openGeneration;
    var instance = document.createElement('div');
    instance.id = 'hs-form-instance-' + generation;
    formWrap.appendChild(instance);

    ensureHsScriptLoaded()
      .then(function () {
        if (generation !== openGeneration) { return; }
        window.hbspt.forms.create({
          region: REGION,
          portalId: PORTAL_ID,
          formId: formId,
          target: '#' + instance.id,
          onFormReady: function () {
            if (generation !== openGeneration) { return; }
            loading.style.display = 'none';
          },
          onFormSubmit: function (form) {
            if (generation !== openGeneration) { return; }
            captured = readFormValues(form);
          },
          onFormSubmitted: function (form, data) {
            if (generation !== openGeneration) { return; }
            if (typeof options.onFormSubmitted === 'function') {
              var values = (data && data.submissionValues) || captured || readFormValues(form);
              options.onFormSubmitted(values || {});
            }
          },
        });
      })
      .catch(function (err) {
        if (generation !== openGeneration) { return; }
        loading.style.display = 'none';
        window.console && window.console.error('Unable to load HubSpot form.', err);
        if (typeof options.onError === 'function') {
          hideModal();
          options.onError(err);
        }
        else {
          loading.style.display = 'block';
          loading.setAttribute('role', 'alert');
          loading.textContent = Drupal.t('The form could not load. Please try again.');
          var retry = document.createElement('button');
          retry.type = 'button';
          retry.className = 'button';
          retry.textContent = Drupal.t('Try again');
          retry.addEventListener('click', function () {
            hsScriptPromise = null;
            var originalTrigger = lastTrigger;
            openHubspotForm(formId, options);
            lastTrigger = originalTrigger;
          });
          loading.appendChild(retry);
          retry.focus({ preventScroll: true });
        }
      });
  }

  // Public API for components that render their buttons after page load
  // (e.g. the Product Picker Quiz result card).
  Drupal.idexxHubspotModal = {
    open: openHubspotForm,
  };

  Drupal.behaviors.idexxHubspotModal = {
    attach: function (context) {
      // Generic: any element on the page carrying a data-hubspot-form-id
      // attribute turns its inner a.button links into modal triggers. In use
      // by Floating CTA, Floating Bar CTA, Button for Modal Form, and Hero
      // blocks; new bundles can opt in by setting the attribute on their
      // wrapper (from twig) without a JS change. A link can also carry the
      // attribute itself, e.g. a menu link via Menu Link Attributes (the
      // global nav "Book a Demo" button).
      $(once('idexxHubspotModal', '[data-hubspot-form-id]', context)).each(function () {
        var el = this;
        var formId = el.getAttribute('data-hubspot-form-id');
        var $links = el.matches('a, button') ? $(el) : $(el).find('a.button, button.button');

        $links.on('click', function (e) {
          // A per-button form overrides a containing CTA's form (IDX-196).
          // Both can be bound; only the nearest form owner handles the click.
          if (this.closest('[data-hubspot-form-id]') !== el) {
            return;
          }
          // Let modified clicks (new tab/window) follow the link as usual.
          if (this.tagName === 'A' && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) {
            return;
          }
          var href = this.getAttribute('href');
          e.preventDefault();
          var options = {};
          if (href && href !== '#') {
            options.onError = function () { window.location.href = href; };
          }
          openHubspotForm(formId, options);
        });
      });
    },
  };
})(jQuery, Drupal, once);
